var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEasymailing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "14.48mm",
    height: "12.7mm",
    viewBox: "0 0 41.03 35.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.6,22V5.39c0-2-2.2-3.5-4.8-3.5S0,3.49,0,5.39v23C.7,28.39,9.3,29.29,9.6,22Z",
    transform: "translate(0 0)",
    style: {
      fill: "#38afbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3,22V5.39c0-2,2.2-3.5,4.8-3.5s4.8,1.6,4.8,3.5v23C40.3,28.39,31.6,29.29,31.3,22Z",
    transform: "translate(0 0)",
    style: {
      fill: "#38afbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,1.19a5.29,5.29,0,0,0-6.8.1L20.6,12.49h0L8.3,1.49a5.17,5.17,0,0,0-6.8,0A4,4,0,0,0,1,7.09c.1.2.3.3.5.5l14.3,12.7v12.2c0,2,2.2,3.5,4.8,3.5s4.8-1.6,4.8-3.5v-12L39.7,7.29a4.06,4.06,0,0,0,.4-5.6C39.8,1.49,39.7,1.29,39.5,1.19Z",
    transform: "translate(0 0)",
    style: {
      fill: "#28d6d6"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasymailing);
export default __webpack_public_path__ + "static/media/easymailing.d15b42486341e80df1448b9e1bb1dd68.svg";
export { ForwardRef as ReactComponent };